import { useEffect, useState } from "react";

/**
 * Debounces a value — returns the latest `value` only after `delay` ms
 * have elapsed without further changes. Handy for search inputs that
 * should not hammer the backend on every keystroke.
 */
export function useDebouncedValue(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return debounced;
}
